import { Modal } from ".";
import { useState } from "react";
import { formatSortCode, cn } from "@utils";

export const BacsModal = ({
  merchant,
  reference,
  className,
  inline = false,
}) => {
  const [copied, setCopied] = useState(false);
  const [show, setShow] = useState(false);

  const handleCopy = (label, text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(label);
      setTimeout(() => setCopied(null), 2000); // Reset copied state after 2 seconds
    });
  };

  const row = (label, value, format, end) => (
    <div
      className={`flex ${
        !end && "border-b"
      } justify-between border-zinc-200 text-sm py-5 `}
    >
      <div>
        <p className="text-zinc-500 mb-1">{label}</p>
        <p className="font-medium">{format ? format(value) : value}</p>
      </div>
      <button
        onClick={() => handleCopy(label, value)}
        className="text-primary font-medium cursor-pointer"
      >
        {copied === label ? "Copied!" : "Copy"}
      </button>
    </div>
  );

  return (
    <p
      className={cn(
        "text-zinc-500 text-sm font-medium my-4",
        inline && "text-zinc-700 font-normal my-0",
        className
      )}
    >
      {inline ? "You can pay by Bank, Card or " : "Can’t pay online? "}
      <span
        role="button"
        onClick={() => setShow(true)}
        className={cn(inline ? "text-primary " : "underline", "cursor-pointer")}
      >
        {inline ? "using our bank details" : "View our bank payment details"}
      </span>
      <Modal
        isOpen={show}
        onClose={() => setShow(false)}
        title="Bank payment information"
      >
        <div className="p-4">
          <p className="text-zinc-500 border-b border-zinc-200 text-center pb-8 font-medium text-sm">
            Complete your payment using the bank account details below
          </p>
          {row("Account name", merchant.name)}
          {row("Account number", merchant.accountNumber)}
          {row("Sort code", merchant.sortCode, formatSortCode)}
          {row("Payment reference", reference, null, true)}
        </div>
      </Modal>
    </p>
  );
};
